import React from "react";
import { getAwsAssets } from "@src/utils";
import styles from "../../../styles/DownloadCompletedIcon.module.scss";
import { Image } from "@src/components/Image";

const DownloadCompletedIcon = () => {
  return (
    <div className={styles.downloadCompletedIcon}>
      <div className={styles.downloadCompletedIcon__icon}>
        <Image
          src={getAwsAssets("checkIcon.svg", "content")}
          alt="checkIcon"
          height={8}
          width={7}
        />
      </div>
    </div>
  );
};

export default DownloadCompletedIcon;
